/**
 * Single source of truth for step order.
 * To reorder steps, just move items in this array.
 */
export const DATA_INTEGRATION_STEP_ORDER = [
  'connect-channels',
  'data-upload',
  'preparing-data',
  'campaign-match',
  'start-modeling',
  'invite-colleagues',
] as const;

export type DataIntegrationStepId =
  (typeof DATA_INTEGRATION_STEP_ORDER)[number];

/**
 * Get the 1-based step index for sidebar display.
 */
export function getStepIndex(stepId: DataIntegrationStepId): number {
  const index = DATA_INTEGRATION_STEP_ORDER.indexOf(stepId);
  if (index === -1) {
    throw new Error(`Unknown step: ${stepId}`);
  }
  return index + 1;
}

/**
 * Get the path for the next step, or null if this is the last step.
 */
export function getNextStepPath(stepId: DataIntegrationStepId): string | null {
  const index = DATA_INTEGRATION_STEP_ORDER.indexOf(stepId);
  if (index === -1 || index === DATA_INTEGRATION_STEP_ORDER.length - 1) {
    return null;
  }
  return `/data-integration/${DATA_INTEGRATION_STEP_ORDER[index + 1]}`;
}

/**
 * Get the path for the previous step, or null if this is the first step.
 */
export function getPrevStepPath(stepId: DataIntegrationStepId): string | null {
  const index = DATA_INTEGRATION_STEP_ORDER.indexOf(stepId);
  if (index <= 0) {
    return null;
  }
  return `/data-integration/${DATA_INTEGRATION_STEP_ORDER[index - 1]}`;
}
